/** @jsx jsx */
import { jsx } from '@emotion/core';
export default (function (_a) {
    var children = _a.children;
    return (jsx("span", { css: {
            display: 'flex;',
            flexShrink: 0,
            position: 'relative',
        } }, children));
});
//# sourceMappingURL=CheckboxWrapper.js.map